<nav class="breadcrumb" aria-label="Breadcrumb">
  <ol class="breadcrumb__list">
    @for (item of items(); track item.label; let last = $last) {
      <li class="breadcrumb__item" [class.breadcrumb__item--current]="last">
        @if (!last && item.route) {
          <a class="breadcrumb__link" [routerLink]="item.route" [queryParams]="item.queryParams">{{ item.label }}</a>
        } @else {
          <span class="breadcrumb__current" aria-current="page">{{ item.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
